import React, {useEffect, useImperativeHandle, useState, useCallback, useRef} from 'react';
import {PopoverBody, PopoverHeader, Popover} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import {Mask} from '@tboerc/maskfy';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {FaRegQuestionCircle} from 'react-icons/fa';
import swal from 'sweetalert';

import {isEmptyObject} from '../../../../helpers';
import {aplicar_taxas, aplicar_taxas_modais, aplicar_taxas_bici_basico, aplicar_taxas_eMoto} from '../../../../helpers/taxas';
import {strings} from '../../../../assets';
import {api} from '../../../../services';
import {Slider} from '../../../../components/atoms';

const CALLER = 'COBERTURA';

const INITIAL_VALUES = {
  coberturas: [],
  porcentagens: {
    acessorios_equipamentos: 20,
    resp_civil_corporais: 100,
    resp_civil_materiais: 100,
    acessorios_ciclomotor: 20,
    acidentes_pessoais_ciclomotor: 100,
  },
};

const Cobertura = ({position, isAdvance, current, checkAdvance, extraData, prevData, corPrimaria}) => {
  const [showPlan, setShowPlan] = useState({});
  const [data, setData] = useState(false);
  const [, setTotal] = useState(0);
  const [comTaxa, setComTaxa] = useState(null);
  const [isOpen, setIsOpen] = useState('');
  const sizeRef = useRef();

  useImperativeHandle(ref, () => ({
    values: () => ({caller: CALLER, data: {cobertura: {...values}}}),
    ref: sizeRef,
  }));

  const validationSchema = Yup.object().shape({
    coberturas:
      prevData.modal === 3
        ? Yup.array()
            .required()
            .test('Erro Cobs', 'Erro Cobs', async (cobs) => {
              console.log(cobs);
              if (cobs.find(({id: cobId}) => cobId === 16 || cobId === 17 || cobId === 18)) return true;
              else if (cobs.find(({id: cobId}) => cobId === 19 || cobId === 20)) {
                if (cobs.find(({id: cobId}) => cobId === 21 || cobId === 22 || cobId === 23)) return false;
                else return true;
              } else return false;
            })
        : Yup.array().required(),
  });

  const {errors, values, setValues, setFieldValue} = useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema: validationSchema,
    initialErrors: strings.INITIAL_ERRORS,
  });

  const funcao = useCallback(() => {
    let newTotal = 0;

    values.coberturas.forEach((cob) => {
      newTotal += parseFloat(comTaxa[cob.label]);
    });

    if (parseFloat(newTotal) < 350) newTotal = comTaxa['soma'];

    setTotal(newTotal);
  }, [comTaxa, values.coberturas]);

  const handleClick = useCallback(
    (plan) => async () => {
      if (plan.id !== 1) {
        let newValues;
        const planAlreadySelectedIndex = values.coberturas.findIndex((c) => +c.id_cobertura === +plan.id);

        if (+planAlreadySelectedIndex !== -1) {
          values.coberturas.splice(planAlreadySelectedIndex, 1);
          setValues({...values, coberturas: values.coberturas});
          funcao();
        } else if (
          (plan.id === 16 || plan.id === 17 || plan.id === 18) &&
          values.coberturas.find(({id, check}) => (id === 16 || id === 17 || id === 18) && check === true)
        ) {
          await swal({
            title: 'Atenção',
            text: 'Selecione apenas uma cobertura "Básica".',
            icon: 'warning',
          });
        } else {
          newValues = [
            ...values.coberturas,
            {id_cobertura: plan.id, valor: parseFloat(comTaxa[plan?.label]).toFixed(2), check: true, ...plan},
          ];
          setValues({...values, coberturas: newValues});
        }
      }
    },
    [comTaxa, funcao, setValues, values],
  );

  const loadData = useCallback(async () => {
    setData(false);

    try {
      /*  const valor_mercado = Mask.money.raw(prevData.segurado_bicicleta.valor);
      const percentual = prevData.segurado_bicicleta.lmi_contratado / 100; */

      const {data: resp} = await api.post('segurado/sura_corretor/coberturas', {
        valor_mercado: prevData.segurado_bicicleta.valor,
        id_modalidade_bicicleta: prevData.segurado_bicicleta.id_modalidade_bicicleta,
      });
      if (resp.status !== 200) throw new Error(resp.message);

      setData(resp.data);
    } catch (e) {
      console.log(e);
    }
  }, [prevData]);

  const changePercentage = useCallback(
    (field) => (value) => {
      setFieldValue('porcentagens.' + field, value);
      funcao();
    },
    [funcao, setFieldValue],
  );

  useEffect(() => {
    if (data && comTaxa !== null) {
      if (values.coberturas.length === 0) {
        const basicPlan = extraData.coberturas.find((cob) => cob.id === 1);
        const assistencia_ciclomotor = extraData.coberturas.find((cob) => cob.label === 'assistencia_ciclomotor');

        setFieldValue(
          'coberturas',
          prevData.modal === 3
            ? [
                {
                  id_cobertura: assistencia_ciclomotor.id,
                  valor: comTaxa[assistencia_ciclomotor?.label]?.toFixed(2),
                  check: true,
                  ...assistencia_ciclomotor,
                },
              ]
            : [{id_cobertura: basicPlan.id, valor: comTaxa[basicPlan?.label]?.toFixed(2), check: true, ...basicPlan}],
        );
      }
    }
  }, [comTaxa, data, extraData.coberturas, setFieldValue, values.coberturas]);

  useEffect(() => {
    setShowPlan({...extraData.coberturas[0]});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log({errors});
    if (current === position) loadData();
    if (current === position) checkAdvance({caller: CALLER, status: isEmptyObject(errors)});
  }, [checkAdvance, current, errors, loadData, position]);

  useEffect(() => {
    if (current === position - 1) setValues(INITIAL_VALUES);
  }, [current, position, setValues]);

  useEffect(() => {
    if (data) {
      if (prevData.modal === 0) {
        setComTaxa(aplicar_taxas(data.valor_mercado, data.taxas, values.porcentagens, values.coberturas));
      } else if (prevData.modal === 2) {
        setComTaxa(
          aplicar_taxas_bici_basico(
            Mask.money.raw(prevData.segurado_bicicleta.valor),
            prevData.segurado_bicicleta.id_modalidade_bicicleta,
            values.porcentagens,
            values.coberturas,
            prevData.segurado_bicicleta.lmi_contratado,
          ),
        );
      } else if (prevData.modal === 3) {
        setComTaxa(
          aplicar_taxas_eMoto(
            Mask.money.raw(prevData.segurado_bicicleta.valor),
            values.porcentagens,
            values.coberturas,
            prevData.segurado_bicicleta.lmi_contratado,
          ),
        );
      } else {
        setComTaxa(
          aplicar_taxas_modais(
            prevData.segurado_bicicleta?.id_modalidade_bicicleta,
            Mask.money.raw(prevData.segurado_bicicleta?.valor),
            values.porcentagens,
            values.coberturas,
          ),
        );
      }
    }
  }, [data, prevData.modal, prevData.segurado_bicicleta, values.porcentagens, values.coberturas]);

  /* 
  useEffect(() => {
    if (showPlan.id !== 1) {
      let newValues;
      const planAlreadySelectedIndex = values.coberturas.findIndex((c) => +c.id_cobertura === +showPlan.id);
      if (+planAlreadySelectedIndex !== -1) {
        values.coberturas.splice(planAlreadySelectedIndex, 1);
        setValues({...values, coberturas: values.coberturas});

        newValues = [
          ...values.coberturas,
          {id_cobertura: showPlan.id, valor: parseFloat(comTaxa[showPlan?.label]).toFixed(2), check: true, ...showPlan},
        ];
        setValues({...values, coberturas: newValues});
      }
    }
  }, [comTaxa]); */

  useEffect(() => {
    if (comTaxa !== null) {
      funcao();
    }
  }, [comTaxa, funcao]);

  return (
    <form className="formStep" ref={sizeRef}>
      <div className="controlForms">
        <div className="leftSide">
          <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Coberturas</h1>
          <p className="mt-4">Veja e selecione as coberturas escolhidas pelo usuário.</p>

          <div className="planToShow">
            <div className="planToShowHeader" style={{background: !!corPrimaria ? corPrimaria : '#023a86'}}>
              <p>{showPlan?.nome}</p>
              <p>{comTaxa && Mask.money.value(parseFloat(comTaxa[showPlan?.label]).toFixed(2))}</p>
            </div>

            <div className="planToShowBody">
              <div className="planItem">
                <span>Franquia</span>
                <p>{showPlan?.franquia}</p>
              </div>
              <div className="planItem">
                <span>Descrição</span>
                <p>{showPlan?.descricao}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="rightSide">
          <div className="controlPlansOffered">
            <div className="plansOffered">
              {extraData.coberturas.map((item) => {
                const iChecked = values.coberturas.find((c) => c.id_cobertura === item.id);
                const slider = item.id === 6 || item.id === 7 || item.id === 8 || item.id === 22 || item.id === 23 ? true : false;

                if (
                  prevData.modal === 2 &&
                  (item.label === 'ext_ambito_territorial' || item.label === 'ext_utilizacao_competicoes')
                )
                  return null;
                else
                  return (
                    <div
                      key={item.label}
                      className={`plan ${showPlan.id === item.id && 'nowUSee'}`}
                      onMouseEnter={() => setShowPlan({...item})}>
                      <div
                        className="checkPlan"
                        style={{
                          background: !!corPrimaria ? corPrimaria : '#023a86',
                          borderColor: !!corPrimaria ? corPrimaria : '#023a86',
                        }}
                        onClick={handleClick(item)}>
                        <span className="radioToCheck">{iChecked && <i />}</span>
                      </div>

                      <div className="planContainer">
                        <div className="planHeader">
                          <p>{item.nome}</p>
                          {isMobile && (
                            <button
                              onClick={() => setIsOpen((prevState) => (prevState === item.label ? '' : item.label))}
                              className="infosButton"
                              type="button">
                              <FaRegQuestionCircle />
                            </button>
                          )}
                        </div>

                        <div
                          id={item.label}
                          onClick={() => setIsOpen((prevState) => (prevState === item.label ? '' : item.label))}
                          className="planDescription">
                          <p>{item.franquia}</p>
                          {iChecked && slider && (
                            <Slider
                              suffix={'%'}
                              textClass="slider-text"
                              min={item.slider_config.min}
                              max={item.slider_config.max}
                              step={item.slider_config.step}
                              containerClass="align-self-end prefixContainer"
                              onChange={changePercentage(item.label)}
                              prefixClass="text-dark font-weight-normal mr-1"
                              defaultValue={INITIAL_VALUES.porcentagens[item.label]}
                            />
                          )}
                        </div>
                      </div>

                      {isMobile && (
                        <Popover isOpen={isOpen === item.label ? true : false} placement="top" target={item.label}>
                          <PopoverHeader>{item.nome}</PopoverHeader>
                          <PopoverBody>{item.descricao}</PopoverBody>
                        </Popover>
                      )}
                    </div>
                  );
              })}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default React.memo(Cobertura);
export const ref = React.createRef();
